import { render, staticRenderFns } from "./MultilanguageText.vue?vue&type=template&id=688c7511&"
import script from "./MultilanguageText.vue?vue&type=script&lang=js&"
export * from "./MultilanguageText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports